import Request from'./request';

export default class ConsolidatedLogsService {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new ConsolidatedLogsService());
	}

	getConsolidatedLogs(logFilter) {
		return Request.instance().post('/console/v1/consolidated/log', logFilter);
	}
}